module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "Ranking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clasificación"])},
        "Market Capital": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capital de Mercado"])},
        "Actual Price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio actual"])},
        "Variation 24hs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variacion 24hs"])},
        "Lowest Price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio más bajo"])},
        "Hightest Price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio más alto"])},
        "Average Price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio Promedio"])},
        "Value in": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valor en "])},
        "Best Exchange Offers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mejores Ofertas de Cambio"])},
        "Get Link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obtener enlace"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"es":{"Ranking":"Clasificación","Market Capital":"Capital de Mercado","Actual Price":"Precio actual","Variation 24hs":"Variacion 24hs","Lowest Price":"Precio más bajo","Hightest Price":"Precio más alto","Average Price":"Precio Promedio","Value in":"Valor en ","Best Exchange Offers":"Mejores Ofertas de Cambio","Get Link":"Obtener enlace"}}')
  delete Component.options._Ctor
  
}
